"use client";

import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "@/domain/ui/Button";
import { DiscordButton } from "@/domain/ui/DiscordButton";

export function ForbiddenError({ message, signOut }: { message?: string; signOut?: () => void }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      console.error(message);
    }
  }, [message]);

  return (
    <div className="mx-auto flex min-h-dvh flex-col items-center justify-center gap-8 p-8 md:gap-12 md:p-16">
      <div className="text-center">
        <h1 className="mb-4 text-3xl font-bold">403</h1>
        <h2 className="mb-3 text-2xl font-semibold">Forbidden</h2>
        <p>Access to this resource is forbidden. You don't have the necessary permissions to view this page.</p>
        {message && <p className="pt-2 text-sm">{message}</p>}
        <div className="mt-6 flex items-center justify-center gap-4 md:mt-8">
          {signOut ? (
            <Button onClick={signOut}>Sign Out</Button>
          ) : (
            <Button className="cursor-pointer" onClick={() => navigate("/dashboard")}>
              Go Back Home
            </Button>
          )}
          <DiscordButton variant="outline" className="flex cursor-pointer items-center gap-1">
            Contact GamingCouch Support
          </DiscordButton>
        </div>
      </div>
    </div>
  );
}
